import React from 'react';
import offplannerLogo from '../images/offplanner-logo.png';
import primoLogo from '../images/MrPrimo-LOGO-sm.png';
import './LoadingSplash.css';

/**
 * Loading splash screen component
 * Displays when the app is loading
 */
const LoadingSplash = () => {
  return (
    <div className="loading-splash">
      <div className="loading-content">
        <div className="main-logo">
          <img src={offplannerLogo} alt="OffPlanner Logo" />
        </div>
        <div className="loading-spinner">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <div className="company-logo">
          <img src={primoLogo} alt="MrPrimo Logo" />
        </div>
      </div>
    </div>
  );
};

export default LoadingSplash;
